<template>
    <el-dialog append-to-body :visible="visible" center @close="onCancel" class="paymen-dialog" width="800px">
        <div ref="pdf" class="pdf-content">
            <div class="statement">
                <div class="title">结算单</div>
                <div class="flex">
                    <div class="item">
                        <label>授权方</label>
                        <div class="text">
                            {{ detail.cpName }}
                        </div>
                    </div>
                    <div class="item">
                        <label>签约公司</label>
                        <div class="text">
                            {{ detail.myCompanyName || '' }}
                        </div>
                    </div>
                </div>
                <div class="flex">
                    <div class="item">
                        <label>结算货币</label>
                        <div class="text">
                            {{ detail.currency }}
                        </div>
                    </div>
                    <div class="item">
                        <label>结算月份</label>
                        <div class="text">
                            {{ $utils.formatDate(detail.beginTime, 'yyyy-MM') }}
                            - {{ $utils.formatDate(detail.endTime, 'yyyy-MM') }}
                        </div>
                    </div>
                </div>
                <div
                    class="flex"
                    v-for="(item, index) in detail.bizAccountings"
                    :key="index"
                    :style="`${index == 0 ? 'border-bottom: none' : ''};padding: 15px 0;`"
                >
                    <div class="item">
                        <label>本期版税收入</label>
                        <div class="text">{{ item.totalAmount ? (parseInt(item.totalAmount * 100) / 100).toFixed(2) : '0.00' }}{{ detail.currency }}</div>
                    </div>
                    <div class="item">
                        <label>分成比例</label>
                        <div class="text">{{ item.split * 100 }}%</div>
                    </div>
                    <div class="item">
                        <label>抵扣</label>
                        <div class="text">{{ item.deductibleMoney ? (parseInt(item.deductibleMoney * 100) / 100).toFixed(2) : '0.00' }}{{ detail.currency }}</div>
                    </div>
                    <div class="item">
                        <label>合计</label>
                        <div class="text">{{ item.shouldSettlementAmount ? (parseInt(item.shouldSettlementAmount * 100) / 100).toFixed(2) : '0.00' }}{{ detail.currency }}</div>
                    </div>
                </div>
                <h5>账目</h5>
                <ol>
                    <li v-if="detail.adjustmentAccountAmount">
                        <label>本次调账金额</label>
                        {{ detail.adjustmentAccountAmountOperator }} {{ detail.adjustmentAccountAmount }} {{ detail.currency }}
                    </li>
                    <li>
                        <label>分账通（我方）分出金额</label>
                        -{{ detail.ownToAmount || 0 }} {{ detail.currency }}
                    </li>
                    <li>
                        <label>分账通（他人）分入金额</label>
                        +{{ detail.otherToOwnAmount || 0 }}{{ detail.currency }}
                    </li>
                    <li>
                        <label>代缴税费</label>
                        -{{ detail.taxAmount || 0 }}{{ detail.currency }}
                    </li>
                    <li v-if="detail.partnersShouldSettlementAmount">
                        <label>总计</label>
                        {{ detail.partnersShouldSettlementAmount }} {{ detail.currency }}
                    </li>
                </ol>
                <div class="flex ft">
                    <p>合作方负责人签字及盖章</p>
                    <p>时间</p>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onCancel">关闭</el-button>
            <el-button type="primary" @click="downloadPayment">下载</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {toPdf} from '@/assets/js/pdf';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        detail: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        shouldSettlementAmount() {
            const {shouldSettlementAmount, adjustmentAccountAmount, adjustmentAccountAmountOperator} = this.detail || {};
            return adjustmentAccountAmountOperator == '+'
                ? shouldSettlementAmount + adjustmentAccountAmount
                : shouldSettlementAmount - adjustmentAccountAmount;
        },
    },
    data() {
        return {};
    },
    methods: {
        onCancel() {
            this.$emit('update:visible', false);
        },
        downloadPayment() {
            this.$nextTick(() => {
                var cntEle = this.$refs.pdf;
                toPdf(cntEle);
            });
        },
    },
};
</script>
<style lang="scss">
.paymen-dialog {
    .el-dialog__header {
        padding: 0px;
    }

    .pdf-content {
        padding-top: 40px;
    }

    .title {
        font-size: 40px;
        color: $-text-950;
        line-height: 40px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .statement {
        padding: 40px;
        color: $-text-600;
        font-size: 14px;

        .flex {
            justify-content: space-between;
            padding: 30px 0;
            border-bottom: 1px solid $--button-disabled-border-color;

            .text {
                color: $-text-950;
                font-size: 16px;
                margin-top: 10px;
            }
        }

        h5 {
            margin: 20px 0;
            font-size: 20px;
        }

        ol {
            margin-bottom: 40px;

            li {
                line-height: 30px;
                text-align: right;
                display: flex;
                color: $-text-950;

                label {
                    flex: 1;
                    text-align: left;
                    color: $-text-600;
                }
            }
        }

        .ft {
            border-bottom: none;
            padding-bottom: 60px;
            font-size: 16px;

            p {
                flex: 1;
            }
        }
    }
}
</style>
